import React, {memo, useEffect, useState} from 'react';
import {
  Read,
  Remove,
  Token as TokenKey,
  Expire as ExpireKey,
} from '../../utils/localstorage';
import {useDispatch} from 'react-redux';
import {loadJWTUser, onJWTAuthSignout} from 'redux/actions';
import GifLoading from '@shared/gifLoading';

export default memo((props: any) => {
  const {children} = props;
  const [ready, setReady] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const token = Read(TokenKey);
    const expire = Read(ExpireKey);

    if (token) {
      const now = Date.now();
      if (Number(expire) < now) {
        Remove(TokenKey);
        Remove(ExpireKey);
        dispatch(onJWTAuthSignout());
        setReady(true);
      } else {
        dispatch(loadJWTUser());
        setReady(true);
      }
    } else {
      dispatch(onJWTAuthSignout());
      Remove(ExpireKey);
      setReady(true);
    }
  }, [dispatch]);

  return ready ? children : <GifLoading />;
});
